const levels = [
  { id: "low", label: "Low" },
  { id: "medium", label: "Medium" },
  { id: "high", label: "High" },
];

export default function EnergyToggle({ value, onChange }) {
  return (
    <div className="energy-toggle" data-testid="energy-level-toggle">
      <span className="energy-label">Energy</span>
      <div className="energy-buttons">
        {levels.map((level) => (
          <button
            key={level.id}
            className={`energy-btn ${value === level.id ? "active" : ""}`}
            onClick={() => onChange(level.id)}
            data-testid={`energy-btn-${level.id}`}
          >
            {level.label}
          </button>
        ))}
      </div>
    </div>
  );
}
